var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMoniker = function SvgMoniker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0L0 50l50 50 50-50zm0 2.777l47.225 47.225L50 97.225 2.775 50.002zm0 2.677L5.454 50.002 50 94.548l44.546-44.546L50 5.454zm0 6.945l37.601 37.603L50 87.603 12.399 50.002 50 12.399zm11.973 27.575c-2.548 0-4.78 1.409-6.064 3.52a7.002 7.002 0 00-1.14-.105c-2.034 0-3.867.655-5.17 2.094.259.287.511.581.725.904.411-.064.83-.108 1.254-.108 2.663 0 5.011 1.507 6.448 3.428a3.943 3.943 0 011.475-.307c1.278 0 2.414.625 3.24 1.615h10.802c0-2.549-1.953-4.617-4.365-4.617-.03 0-.06.008-.094.008-.544-3.64-3.515-6.432-7.11-6.432zm-19.665 5.648c-3.974 0-7.528 3.694-8.128 7.69-.036-.003-.067-.011-.106-.011-2.662 0-4.817 3.17-4.817 5.962h33.259c-.13-1.323-.607-3.4-1.297-4.303-.828-1.095-1.971-1.79-3.258-1.79-.522 0-1.014.138-1.48.343C55.034 51.388 52.675 50 50 50c-.43 0-.849.046-1.26.115a7.711 7.711 0 00-.733-1.001c-1.459-1.745-3.315-3.492-5.7-3.492z",
    fill: "#f0cf75",
    fillOpacity: 1,
    strokeWidth: 0.036
  })));
};

export default SvgMoniker;